// extracted by mini-css-extract-plugin
export default {"tabs":"IndicatorsTabs_tabs__qo+4I","tab":"IndicatorsTabs_tab__uOJqN","tabActive":"IndicatorsTabs_tabActive__1cFDx"};